import {AbstractFilter} from '@gongxigames/framework/slot';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class GameBonusFilter extends AbstractFilter {
    protected bonus: number;

    constructor(name: string, bonus: number) {
        super(name);
        this.bonus = bonus;
    }

    public filter(response: Message): boolean {
        if (response.getAction() === Action.SPIN) {
            return this.getSpin(response).bonusId === this.bonus;
        }

        return true;
    }
}
